export default __webpack_public_path__ + "static/media/Transfer_certificate_3.aec737a6.svg";